import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const ContactsPositionWUT = (props)=>{
    const fieldType = FIELD_TYPES.CONTACTS_POSITION;
    return /*#__PURE__*/ React.createElement(TextInputFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=contacts-position-wut.js.map